import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Avatar,
  Stack,
  Tooltip,
  Zoom,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import moment from "moment";
import { style } from "../../../../assets/MUIStyles/emailThread";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { emailConversationsAction } from "../../ProjectSection/Agents/Store/Agent.action";
import { getDecryptedItem } from "../../../../utils/localStorageHelper";
import { LoadingSlides } from "../../CommonComponents/Common";
import EmptyState from "../../Common/EmptyState";

const EmailThread = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { projectId } = useParams<{ projectId: string }>();
  const { threadId }: { threadId: string } = useParams();
  const [emailThread, setEmailThread] = useState<any>(null);
  const [expandedMsgIndex, setExpandedMsgIndex] = useState<number | false>(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const email = getDecryptedItem("thread-email");

    const getEmailThread = async (email: string, threadId: string) => {
      const payload = { email, threadId };
      const emailConversations: any = await dispatch(
        emailConversationsAction(payload)
      );
      if (emailConversations) {
        setEmailThread({
          messages: emailConversations?.messages,
          subject: emailConversations?.messages?.[0]?.subject,
        });
        setExpandedMsgIndex(0);
      } else {
        setEmailThread(null);
      }
      setLoading(false);
    };

    getEmailThread(email, threadId);
  }, []);

  if (loading) {
    return (
      <Box className="flex-xy-center" sx={{ height: "74vh" }}>
        <LoadingSlides bgColor="rgba(255, 94, 0, 0.75)" />
      </Box>
    );
  }

  return (
    <Box sx={{ m: 1, ...style.emailThreadContainer }}>
      <Box>
        <Tooltip
          title="Back"
          slots={{
            transition: Zoom,
          }}
        >
          <span>
            <IconButton
              onClick={() =>
                history.push(`/account/project/${projectId}/threads/email`)
              }
            >
              <KeyboardBackspaceIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      {emailThread ? (
        <Box sx={{ m: 2, ...style.threadContainer }}>
          <Typography className="font-18-600-grey " sx={{ ml: 3, mb: 3 }}>
            {emailThread?.subject}
          </Typography>

          <Stack spacing={0}>
            {emailThread?.messages?.map((msg: any, idx: number) => (
              <MessageCard
                key={idx}
                msg={msg}
                expanded={expandedMsgIndex === idx}
                onChange={() =>
                  setExpandedMsgIndex(expandedMsgIndex === idx ? false : idx)
                }
              />
            ))}
          </Stack>
        </Box>
      ) : (
        <EmptyState message="No messages found" />
      )}
    </Box>
  );
};

export default EmailThread;

const MessageCard = ({ expanded, onChange, msg }) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      disableGutters
      square
      sx={style.accordian}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={style.accordianSummary}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "center",
            width: "100%",
          }}
        >
          <Avatar sx={style.avatar} />
          <Box
            sx={{
              flex: 1,
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                color: "text.primary",
              }}
            >
              {msg?.from}
            </Typography>
            <Typography className="font-12-400-lightgrey">
              {moment(msg?.date).format("ddd, DD MMM YYYY, HH:mm a")}
            </Typography>
          </Box>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, pb: 2, px: 7 }}>
        <Box
          dangerouslySetInnerHTML={{ __html: msg?.body }}
          sx={{
            fontSize: 14,
            color: "text.primary",
            whiteSpace: "pre-wrap",
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};
